export default __webpack_public_path__ + "static/media/doguinho.afe2df9d.png";